export default __webpack_public_path__ + "static/media/SFX_Background.9e7ba008.jpg";